export default "__VITE_ASSET__B5bNdBTZ__"